/* eslint-disable no-shadow */
import profileApiClient from '../../services/profile/profile-service';

const state = {
	brandingPartners: [],
	newPartner: {
		id: 0,
		name: '',
		companyName: '',
		addressLine1: '',
		addressLine2: '',
		city: '',
		state: '',
		zipCode: '',
		phoneNumber: '',
		phoneExtension: '',
		emailAddress: '',
		websiteUrl: '',
		additionalInfo: 'string',
		activeIndicator: true,
		partnerImage: {
			imageFormat: '',
			imageUri: '',
			referenceId: '',
		},
	},
	tempPartner: {
		id: 0,
		name: '',
		companyName: '',
		addressLine1: '',
		addressLine2: '',
		city: '',
		state: '',
		zipCode: '',
		phoneNumber: '',
		phoneExtension: '',
		emailAddress: '',
		websiteUrl: '',
		additionalInfo: 'string',
		activeIndicator: true,
		partnerImage: {
			imageFormat: '',
			imageUri: '',
			referenceId: '',
		},
	},
};

const mutations = {
	SET_PARTNERS(state, payload) {
		state.brandingPartners = payload;

		// tempPartner acts as a sort of template so that we can reset the newPartner object
		Object.freeze(state.tempPartner);
	},

	CREATE_PARTNER(state) {
		Object.assign(state.newPartner, state.tempPartner);
	},

	CREATE_NEW_PARTNER(state, partner) {
		state.brandingPartners.push(partner);
	},

	SAVE_PARTNER(state, { partner, partnerIndex }) {
		Object.assign(state.brandingPartners[partnerIndex], partner);
	},

	UPDATE_PARTNER(state, partner) {
		Object.assign(state.newPartner, partner);
	},

	DELETE_PARTNER(state, index) {
		state.brandingPartners[index].activeIndicator = false;
	},

	UPLOAD_PARTNER_PHOTO(state, { format, secureUrl, publicId }) {
		state.newPartner.partnerImage.imageUri = secureUrl;
		state.newPartner.partnerImage.imageFormat = format;
		state.newPartner.partnerImage.referenceId = publicId;
	},

	DELETE_PARTNER_PHOTO(state) {
		state.newPartner.partnerImage.imageUri = '';
		state.newPartner.partnerImage.imageFormat = '';
		state.newPartner.partnerImage.referenceId = '';
	},

	UPDATE_PARTNER_DETAILS(state, { fieldName, value }) {
		state.newPartner[fieldName] = value;
	},
};

const actions = {
	async setPartners({ commit }, partners) {
		commit('SET_PARTNERS', partners);
	},

	savePartner({ commit, state }, partner) {
		const partnerIndex = state.brandingPartners.findIndex(
			(el) => el.id === partner.id,
		);
		console.log(
			'partners>>>',
			state.brandingPartners,
			'\rpartnerIndex>>>',
			partnerIndex,
			'\rtargetPartner>>>',
			partner,
		);
		if (partnerIndex >= 0) {
			commit('SAVE_PARTNER', { partner, partnerIndex });
		} else {
			commit('CREATE_NEW_PARTNER', partner);
		}
	},

	createPartner({ commit }) {
		commit('CREATE_PARTNER');
	},

	updatePartner({ commit }, partner) {
		commit('UPDATE_PARTNER', partner);
	},

	async deletePartner({ commit, state, rootState }, partner) {
		const { id } = partner;
		const { brandingPartners } = state;
		const index = brandingPartners.findIndex((el) => el.id === id);
		commit('DELETE_PARTNER', index);
		partner.activeIndicator = false;
		await profileApiClient.savePartners(rootState.profile.contactId, partner);
	},

	uploadPartnerPhoto({ commit }, profilePhoto) {
		commit('UPLOAD_PARTNER_PHOTO', profilePhoto);
	},

	deletePartnerPhoto({ commit }) {
		commit('DELETE_PARTNER_PHOTO');
	},

	updatePartnerDetails({ commit }, data) {
		commit('UPDATE_PARTNER_DETAILS', data);
	},
};

export default {
	state,
	actions,
	mutations,
};
